import { AxiosResponse } from "axios"
import { call, select, takeEvery } from "redux-saga/effects"
import { AppService } from "src/services/app"
import { getBaseUrl } from "../selectors/features/app"
import { RequestTypes } from "../types"

const appservice = new AppService()

function* getBulkSendChainSaga(action: any) {
  const { payload } = action
  const { id } = payload
  try {
    const baseUrl: string = yield select(getBaseUrl)
    const response: AxiosResponse<any> = yield call(appservice.getBulkSendChain, baseUrl, id)
    payload?.cbSuccess && payload?.cbSuccess({ ...response })
  } catch (error: any) {
    payload?.cbFailure && payload?.cbFailure(error?.statusText || "chain failed")
  }
}

// takeEvery allows concurrent fetches so rapid calls are not cancelled
export function* watchGetBulkSendChain() {
  yield takeEvery(RequestTypes.GET_BULK_SEND_CHAIN, getBulkSendChainSaga)
}
